// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.catalog-manager {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.catalog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #e0e0e0;
}

.catalog-header h2 {
  margin: 0;
  color: #1e3a8a;
  font-size: 24px;
}

.catalog-actions {
  display: flex;
  gap: 15px;
  align-items: center;
}

.filter-buttons {
  display: flex;
  gap: 5px;
  background: #f5f5f5;
  padding: 4px;
  border-radius: 6px;
}

.filter-buttons button {
  padding: 6px 12px;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;
}

.filter-buttons button:hover {
  background: #e0e0e0;
}

.filter-buttons button.active {
  background: #1e3a8a;
  color: white;
  font-weight: 500;
}

.btn-primary {
  background: #1e3a8a;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
}

.btn-primary:hover {
  background: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(30, 58, 138, 0.3);
}

.btn-secondary {
  background: #6b7280;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.btn-secondary:hover {
  background: #4b5563;
}

.catalog-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.catalog-table thead {
  background: #1e3a8a;
  color: white;
}

.catalog-table th,
.catalog-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.catalog-table th {
  font-weight: 600;
  font-size: 14px;
}

.catalog-table tbody tr {
  transition: background 0.2s;
}

.catalog-table tbody tr:hover {
  background: #f9fafb;
}

.catalog-table tbody tr.inactive-row {
  opacity: 0.6;
  background: #f3f4f6;
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.status-badge.active {
  background: #d1fae5;
  color: #065f46;
}

.status-badge.inactive {
  background: #fee2e2;
  color: #991b1b;
}

.actions-cell {
  display: flex;
  gap: 8px;
}

.btn-small {
  background: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s;
}

.btn-small:hover {
  background: #f3f4f6;
  transform: scale(1.1);
}

.btn-edit:hover {
  background: #dbeafe;
}

.btn-toggle:hover {
  background: #fef3c7;
}

.btn-delete:hover {
  background: #fee2e2;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #6b7280;
  font-size: 16px;
}

.error-message {
  background: #fee2e2;
  color: #991b1b;
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 15px;
  border-left: 4px solid #dc2626;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 1200px;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  animation: slideUp 0.3s;
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.modal-header h3 {
  margin: 0;
  color: #1e3a8a;
  font-size: 20px;
}

.modal-close {
  background: transparent;
  border: none;
  font-size: 24px;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  transition: all 0.2s;
}

.modal-close:hover {
  background: #f3f4f6;
  color: #1f2937;
}

.form-body {
  padding: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  color: #374151;
  font-weight: 500;
  font-size: 14px;
}

.form-group .required {
  color: #dc2626;
  margin-left: 4px;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #1e3a8a;
  box-shadow: 0 0 0 3px rgba(30, 58, 138, 0.1);
}

.form-group input[type="checkbox"] {
  width: auto;
  margin-right: 8px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
}

/* Responsive */
@media (max-width: 768px) {
  .catalog-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .catalog-actions {
    width: 100%;
    flex-direction: column;
  }

  .filter-buttons {
    width: 100%;
  }

  .filter-buttons button {
    flex: 1 1;
  }

  .catalog-table {
    font-size: 12px;
  }

  .catalog-table th,
  .catalog-table td {
    padding: 8px;
  }

  .modal-content {
    width: 95%;
    margin: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/catalogs/CatalogManager.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,qFAAqF;EACrF,uBAAuB;AACzB;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,YAAY;EACd;AACF","sourcesContent":[".catalog-manager {\r\n  padding: 20px;\r\n  background: #fff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.catalog-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n  padding-bottom: 15px;\r\n  border-bottom: 2px solid #e0e0e0;\r\n}\r\n\r\n.catalog-header h2 {\r\n  margin: 0;\r\n  color: #1e3a8a;\r\n  font-size: 24px;\r\n}\r\n\r\n.catalog-actions {\r\n  display: flex;\r\n  gap: 15px;\r\n  align-items: center;\r\n}\r\n\r\n.filter-buttons {\r\n  display: flex;\r\n  gap: 5px;\r\n  background: #f5f5f5;\r\n  padding: 4px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.filter-buttons button {\r\n  padding: 6px 12px;\r\n  border: none;\r\n  background: transparent;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.filter-buttons button:hover {\r\n  background: #e0e0e0;\r\n}\r\n\r\n.filter-buttons button.active {\r\n  background: #1e3a8a;\r\n  color: white;\r\n  font-weight: 500;\r\n}\r\n\r\n.btn-primary {\r\n  background: #1e3a8a;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background: #2563eb;\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 8px rgba(30, 58, 138, 0.3);\r\n}\r\n\r\n.btn-secondary {\r\n  background: #6b7280;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.btn-secondary:hover {\r\n  background: #4b5563;\r\n}\r\n\r\n.catalog-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-top: 10px;\r\n}\r\n\r\n.catalog-table thead {\r\n  background: #1e3a8a;\r\n  color: white;\r\n}\r\n\r\n.catalog-table th,\r\n.catalog-table td {\r\n  padding: 12px;\r\n  text-align: left;\r\n  border-bottom: 1px solid #e0e0e0;\r\n}\r\n\r\n.catalog-table th {\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n}\r\n\r\n.catalog-table tbody tr {\r\n  transition: background 0.2s;\r\n}\r\n\r\n.catalog-table tbody tr:hover {\r\n  background: #f9fafb;\r\n}\r\n\r\n.catalog-table tbody tr.inactive-row {\r\n  opacity: 0.6;\r\n  background: #f3f4f6;\r\n}\r\n\r\n.status-badge {\r\n  display: inline-block;\r\n  padding: 4px 12px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.status-badge.active {\r\n  background: #d1fae5;\r\n  color: #065f46;\r\n}\r\n\r\n.status-badge.inactive {\r\n  background: #fee2e2;\r\n  color: #991b1b;\r\n}\r\n\r\n.actions-cell {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.btn-small {\r\n  background: transparent;\r\n  border: none;\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.btn-small:hover {\r\n  background: #f3f4f6;\r\n  transform: scale(1.1);\r\n}\r\n\r\n.btn-edit:hover {\r\n  background: #dbeafe;\r\n}\r\n\r\n.btn-toggle:hover {\r\n  background: #fef3c7;\r\n}\r\n\r\n.btn-delete:hover {\r\n  background: #fee2e2;\r\n}\r\n\r\n.loading {\r\n  text-align: center;\r\n  padding: 40px;\r\n  color: #6b7280;\r\n  font-size: 16px;\r\n}\r\n\r\n.error-message {\r\n  background: #fee2e2;\r\n  color: #991b1b;\r\n  padding: 12px 16px;\r\n  border-radius: 6px;\r\n  margin-bottom: 15px;\r\n  border-left: 4px solid #dc2626;\r\n}\r\n\r\n/* Modal */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  animation: fadeIn 0.2s;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.modal-content {\r\n  background: white;\r\n  border-radius: 12px;\r\n  width: 90%;\r\n  max-width: 1200px;\r\n  max-height: 85vh;\r\n  overflow-y: auto;\r\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\r\n  animation: slideUp 0.3s;\r\n}\r\n\r\n@keyframes slideUp {\r\n  from {\r\n    transform: translateY(20px);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px 24px;\r\n  border-bottom: 1px solid #e5e7eb;\r\n}\r\n\r\n.modal-header h3 {\r\n  margin: 0;\r\n  color: #1e3a8a;\r\n  font-size: 20px;\r\n}\r\n\r\n.modal-close {\r\n  background: transparent;\r\n  border: none;\r\n  font-size: 24px;\r\n  color: #6b7280;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 4px;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.modal-close:hover {\r\n  background: #f3f4f6;\r\n  color: #1f2937;\r\n}\r\n\r\n.form-body {\r\n  padding: 24px;\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.form-group label {\r\n  display: block;\r\n  margin-bottom: 6px;\r\n  color: #374151;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n}\r\n\r\n.form-group .required {\r\n  color: #dc2626;\r\n  margin-left: 4px;\r\n}\r\n\r\n.form-group input,\r\n.form-group select {\r\n  width: 100%;\r\n  padding: 10px 12px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.form-group input:focus,\r\n.form-group select:focus {\r\n  outline: none;\r\n  border-color: #1e3a8a;\r\n  box-shadow: 0 0 0 3px rgba(30, 58, 138, 0.1);\r\n}\r\n\r\n.form-group input[type=\"checkbox\"] {\r\n  width: auto;\r\n  margin-right: 8px;\r\n}\r\n\r\n.modal-footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  padding: 16px 24px;\r\n  border-top: 1px solid #e5e7eb;\r\n  background: #f9fafb;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .catalog-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 15px;\r\n  }\r\n\r\n  .catalog-actions {\r\n    width: 100%;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .filter-buttons {\r\n    width: 100%;\r\n  }\r\n\r\n  .filter-buttons button {\r\n    flex: 1;\r\n  }\r\n\r\n  .catalog-table {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .catalog-table th,\r\n  .catalog-table td {\r\n    padding: 8px;\r\n  }\r\n\r\n  .modal-content {\r\n    width: 95%;\r\n    margin: 10px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
